import { z } from 'zod'
import { useZorm } from 'react-zorm'
import { FormField, fieldDescription } from '@codecorp/zorm-conventions'
import { ShowBarcode } from '../components/show-barcode'
import { CreatorButtons } from '../components/creator-buttons'
import { useFormReset } from '../hooks/use-form'
import { useShowModal } from '../hooks/use-show-modal'

const FormSchema = z.object({
    label: z.string().describe(
        fieldDescription({
            placeHolder: 'This name will be placed under the QR Code.',
        })
    ),
    contents: z
        .string()
        .url()
        .describe(
            fieldDescription({
                label: 'Enter Website URL',
                placeHolder: 'Please make sure your URL includes http(s)://',
            })
        ),
})

export const LinkBarcodeCreator = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)
    const showModal = useShowModal()

    const zo = useZorm('linkBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label}
                    barcode={data.contents}
                />
            )
        },
    })

    return (
        <div>
            <form
                ref={zo.ref}
                className="ml-10 mr-10 leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.contents(FormField)}
                <CreatorButtons />
            </form>
        </div>
    )
}
